<ngx-spinner type="ball-scale-multiple"></ngx-spinner>

<div class="gray-200" style="padding: 20px 40px">
  <form [formGroup]="searchForm" (ngSubmit)="onSearch(searchForm.value)">
    <div>
      <div class="flex-row pb-10">
        <div class="width-full">
          <b>Search For Profile</b>
        </div>
      </div>
      <div class="inline-text-field-container flex-row gap-20 pb-10">
        <div class="ds-text-field basis-30">
          <input class="ds-text-field__input" id="firstName" type="text" name="firstName" formControlName="firstName"
            maxlength="60" autocomplete="off" />
          <label for="firstName" class="ds-floating-label">First Name</label>
          <span class="help display-none"></span>
          <span class="error display-none"></span>
        </div>
        <div class="ds-text-field basis-30">
          <input class="ds-text-field__input" id="oaksident" type="text" name="oaksident" formControlName="oaksident"
            autocomplete="off" maxlength="60" />
          <label for="oaksident" class="ds-floating-label">OAKS ID</label>
          <span class="help display-none"></span>
          <span class="error display-none"></span>
        </div>
        <!-- @if (showSecurity)  -->
        
        <div class="ds-text-field basis-30"
          [style.margin-bottom]="searchForm.get('uuid').invalid && searchForm.get('uuid').errors && (searchForm.get('uuid').dirty || searchForm.get('uuid').touched)?'30px':'10px'">
          <input class="ds-text-field__input" id="uuid" type="text" name="uuid" maxlength="36" formControlName="uuid"
            autocomplete="off" />
          <label for="uuid" class="ds-floating-label">UUID</label>
          <span class="help display-none"></span>
          @if (searchForm.get('uuid').invalid && searchForm.get('uuid').errors && (searchForm.get('uuid').dirty ||
          searchForm.get('uuid').touched)) {
          <div class="error">Enter valid UUID. Max Length allowed 36</div>
          }
        </div>
        
      </div>

      <div class="inline-text-field-container flex-row gap-20 pb-10">
        <div class="ds-text-field basis-30">
          <input class="ds-text-field__input" id="lastName" type="text" name="lastName" formControlName="lastName"
            autocomplete="off" maxlength="60" />
          <label for="lastName" class="ds-floating-label">Last Name</label>
          <span class="help display-none"></span>
          <span class="error display-none"></span>
        </div>

        <div class="ds-text-field chevron basis-30">
          <select class="ds-text-field__input rounded-4 hover-gray-300" id="requestAccountStatusKey" autocomplete="off"
            formControlName="requestAccountStatusKey" placeholder="Status">
            <!-- <option value="null" selected>Select</option> -->
            @for (requestStatus of requestStatusData; track requestStatus ) {
            <option [value]="requestStatus.requestAccountStatusKey">{{requestStatus.accountRequestStatusDesc}}</option>
            }
          </select>
          <label for="requestAccountStatusKey" class="ds-floating-label">Status</label>
          <span class="help display-none"></span>
          <span class="error display-none"></span>
        </div>
      </div>
    </div>
    <div class="border-bottom border-gray-500 mb-10 pb-10">
      <button type="submit" style="margin-right: 20px" class="rounded-4 hover-blue-800 black mobile">
        <div class="btn-txt font-white bold">Search</div>
      </button>
      <button type="button" (click)="resetForm()"
        class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse mobile">
        <div class="btn-txt font-red bold">Reset</div>
      </button>
    </div>
  </form>

  <div>
    <div class="card fluid">
      <div class="card__content">
        <div class="width-full overflow-auto">
          <div class="result-top">
            <div class="text-adjust"> <span class="bold">Displaying</span> {{totalSize}} <span
                class="bold">Records</span></div>
            <div>
              <div class="ds-text-field filter">
                <input class="ds-text-field__input" id="globalFiter" type="text" [(ngModel)]="globalFilter"
                  (keyup)="filterTable($event)" autocomplete="off" />
                <label for="address" class="ds-floating-label">Filter</label>
                <div class="field-line-ripple blue"></div>
                <span class="help display-none"></span>
                <span class="error display-none"></span>
              </div>
            </div>
          </div>
          <div>
            <table class="table-ode">
              <thead>
                <tr>
                  <th appTableSort sortColumn="FirstName" (sortChange)="sortChange($event)">Old Name</th>
                  <th>Status</th>
                  <th appTableSort sortColumn="Oaksident" (sortChange)="sortChange($event)">OAKS ID</th>
                  <th appTableSort sortColumn="BeginTs" (sortChange)="sortChange($event)">Created Date</th>
                </tr>
              </thead>
              <tbody>
                @for (row of currentPageData; track row) {
                <tr>
                  <td class="firstName">
                    <a (click)="onNameClick(row)">
                      {{ row?.currentFirstName}}   {{ row?.currentLastName}}
                    </a>
                  </td>
                  <!-- <td>{{ searchForm.get('requestAccountStatusKey')?.value }}</td> -->
                   <td>{{ row?.requestAccountStatusDesc }}</td>
                  <td>
                    {{ row?.oaksIdent }}
                  </td>
                  <td>{{ row?.createTs | date : "MM/dd/yyyy" }}</td>
                </tr>
                }
              </tbody>
            </table>
            @if (currentPageData && currentPageData?.length > 0) {
            <div class="row">
              <div class="paginator-adjust">
                <eas-ui-lib-paginator [currentPage]="currentPage" [pageSize]="pageSize" [totalSize]="totalSize"
                  (pageChanged)="onPageChanged($event)"></eas-ui-lib-paginator>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>